module.exports = require('./lib/patch')



//////////////////
// WEBPACK FOOTER
// ./~/react-hot-loader/patch.js
// module id = 191
// module chunks = 0